import { Dispatch, FC, Fragment, SetStateAction } from 'react';
import { MeterOptionIndividualReport } from '../../models/MeterOption';
import { Tooltip } from 'primereact/tooltip';
import { modalInternalInfo } from './IndividualStudentReportSkillsModal';

interface Props {
  value: MeterOptionIndividualReport;
  setIndividualModalState: Dispatch<SetStateAction<string | null>>;
}

export const IndividualStudentReportMeterItem: FC<Props> = ({ value, setIndividualModalState }) => {
  return (
    <Fragment>
      <Tooltip target={`.${value.className}`} mouseTrack position="top" />
      <button
        data-pr-tooltip={`${value.skills.length} skills ${modalInternalInfo[value.label].title}`}
        className={`${value.className} bar-md text-center border-none text-0 cursor-pointer`}
        style={{
          width: `${value.width}%`,
          minWidth: '5%',
          padding: `${value.width < 10 && '0'}`,
          fontFamily: 'Poppins',
          marginLeft: value.margin ? '1px' : 0,
        }}
        onClick={() => {
          setIndividualModalState(value.label);
        }}
      ></button>
    </Fragment>
  );
};
